import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ISubscription } from "rxjs/Subscription";
import { LocalUtils } from '../../restricted/restricted.utils';
import {Observable} from "rxjs";
import { AuthenticationService } from '../../auth/authentication.service';
import { HeaderService } from 'app/components/app-header/app.header.service';

@Component({
  selector: 'app-aside',
  templateUrl: './app-aside.component.html'
})
export class AppAsideComponent implements OnInit, OnDestroy {

  private subscription: ISubscription;
  public user: any = {};
  public system: any[] = [];
  public schedules: any[] = [];
  buttonColor: string = 'warning';
  changeRoom;

  constructor(private authService: AuthenticationService) { 
    
    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));

    this.changeRoom = HeaderService.changeRoom.subscribe(() => {
      this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
      if (this.user.myRoom && this.user.myRoom.id) {
        this.getSchedules(this.user.myRoom.id);
      }
    });
  }

  ngOnInit() {
    this.getNotify();
    // if(this.user.myRoom && this.user.myRoom.room){
    //   this.getSchedules(this.user.myRoom.id);
    //   this.subscription = Observable.interval(3600000)
    //   .subscribe(i => { 
    //     this.getNotify();
    //     this.getSchedules(this.user.myRoom.id);
    //   });
    // }
  }

  ngOnDestroy() {
    if (this.subscription != undefined) {
      this.subscription.unsubscribe();
    }
  }
  
  getNotify(){
    return
  }

  getSchedules(roomId){
    return
  }

  start(){
    window.open(this.user.addresses.web + 'join/start', '_blank');
  }

  logout(){
    this.authService.logout();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/app-aside/app-aside.component.ts